import * as React from "react";
import OriginAutosizeTextArea from "react-textarea-autosize";

interface TextareaAutosizeProps extends React.HTMLProps<HTMLTextAreaElement> {
    value?: any;
    onChange?: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
    onHeightChange?: (height: number) => void;
    useCacheForDOMMeasurements?: boolean;
    rows?: number;
    minRows?: number;
    maxRows?: number;
    inputRef?: React.RefObject<HTMLTextAreaElement>;
}

type State = {
    width: number;
};

/**
 * Wrapper on react-textarea-autosize that additionally triggers height recalculation
 * if text area width was changed.
 */
export class AutosizeTextArea extends React.Component<TextareaAutosizeProps, State> {
    private _inputRef: HTMLTextAreaElement;

    inputRefCallback = (current: HTMLTextAreaElement) => {
        this._inputRef = current;
        if (this.props.inputRef) {
            // @ts-ignore
            this.props.inputRef.current = current;
        }
    };

    render() {
        const { ref, style: originalStyle, ...props } = this.props;
        const style: React.CSSProperties = {
            overflow: "hidden",
            ...originalStyle,
        };

        return <OriginAutosizeTextArea {...props} style={style} inputRef={this.inputRefCallback} />;
    }

    componentDidMount() {
        this.setState({ width: this._inputRef.clientWidth });
    }

    componentDidUpdate() {
        if (this.state.width !== this._inputRef.clientWidth) {
            this.setState({ width: this._inputRef.clientWidth });
        }
    }
}
